import script from "./WorkDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkDetail.vue?vue&type=script&setup=true&lang=js"

import "./WorkDetail.vue?vue&type=style&index=0&id=992b9d6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-992b9d6a"]])

export default __exports__